import { useQuery } from "@tanstack/react-query";
import { useActualViewer } from "@softmax/web-features/session/records";
import { useDiscardUnavailableData } from "@softmax/web-features/data";
import { useRoute } from "@softmax/web-features/navigation";
import { leagueDirectoryQueryOptions } from "@softmax/web-features/site/queries";
import { usePillAccount } from "./use-pill-account";
import { usePillCoworld } from "./use-pill-coworld";

export function usePillMenu({
  member,
  playersNeeded,
}: {
  member: boolean;
  playersNeeded: boolean;
}) {
  const route = useRoute();
  const coworld = usePillCoworld();
  const viewer = useActualViewer();
  const viewerId = viewer.data?.subject_id ?? null;
  const account = usePillAccount({ signedIn: member, needed: playersNeeded });
  const options = leagueDirectoryQueryOptions({ viewerId });
  const directory = useQuery({
    ...options,
    enabled: coworld !== null && !viewer.isPending && !viewer.isError,
  });
  const unavailable = useDiscardUnavailableData({
    queryKey: options.queryKey,
    error: directory.error,
  });
  const available = unavailable ? undefined : directory.data;
  const gameSlug = coworld && route.area === "game" ? route.gameSlug : null;
  const entries = available?.entries ?? [];
  const currentLeagues = entries.filter(
    (entry) => entry.route.game.slug === gameSlug,
  );
  return {
    ...account,
    viewerId,
    directory,
    coworld,
    currentLeagues,
    pathname: route.pathname,
  };
}

export type PillMenuData = ReturnType<typeof usePillMenu>;
